<button
  mat-icon-button
  [color]="color"
  *ngFor="let rating of ratingArr; index as i; last as last"
  [id]="'star_' + i"
  (click)="onClick(i + 1)"
>
  <mat-icon>
    {{ rating }}
  </mat-icon>
</button>
<!-- <mat-error *ngIf="starCount == null || starCount == 0">
  Star count is <strong>required</strong> and cannot be zero
</mat-error> -->
